import { Injectable } from '@angular/core';
import { CheckinBaseClass } from '../../components';
import {
  resetGetFlightsResult,
  setGetFlightsResultFromApi,
  selectGetFlightsResultIsFailureStatus,
  selectGetFlightsResultState,
  GetFlightsResultState,
} from '../../store/get-flights-result';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import {
  DefaultService as Api,
  PostFlightsSearchFlightsRequest,
  PostFlightsSearchFlightsResponse,
} from 'src/sdk_checkin';

@Injectable()
export class GetFlightsResultStoreService extends CheckinBaseClass {
  private _result$: Observable<GetFlightsResultState>;
  private _result!: GetFlightsResultState;
  get result() {
    return this._result;
  }

  /** APIエラーSubscription */
  apiErrorResponseSubscription?: Subscription;

  constructor(private _store: Store<GetFlightsResultState>, private api: Api) {
    super();
    this._result$ = this._store.pipe(
      select(selectGetFlightsResultState),
      filter((data) => !!data)
    );
    this.subscribeService(this._result$, (data) => {
      this._result = data;
    });
  }

  override destroy(): void {
    if (!!this.apiErrorResponseSubscription) {
      this.apiErrorResponseSubscription.unsubscribe();
      this.apiErrorResponseSubscription = undefined;
    }
  }

  /**
   * GetFlightsResultStateStore のObservableを返却する
   * @returns GetFlightsResultStateStore の全ての値を取得するObservable
   */
  public getResultState$() {
    return this._result$;
  }

  /**
   * API呼び出しが失敗したかのObservableを返却する
   * @returns isFailureの値を取得するObservable
   */
  public getIsFailure$() {
    return this._store.pipe(
      select(selectGetFlightsResultIsFailureStatus),
      filter((state) => !!state)
    );
  }

  /**
   * チェックイン空港空席待ち人数検索が正常終了したら結果を取得するObservable
   * 1つ前と現在のStoreの状態を監視して、1つ前が呼び出し中かつ、現在の状態が失敗していないかつ呼び出し中でないかつレスポンスが存在する場合に値を流す。
   * (NOTE:フライトリスト取得APIが永続化されるので、API呼び出しが行われた際に値が流れるようにした)
   */
  public getResultStateIfSuccessful$() {
    return this._result$.pipe(
      pairwise(),
      filter(([prev, curr]) => !!prev.isPending && !curr.isFailure && !curr.isPending && !!curr.model),
      map(([_, curr]) => curr)
    );
  }

  /**
   * API呼び出し結果のObservableを受け取りStoreに格納する
   * @param call API呼び出し結果を取得するObservable
   */
  private setResult(call: Observable<PostFlightsSearchFlightsResponse>) {
    this._store.dispatch(setGetFlightsResultFromApi({ call }));
  }

  /**
   * チェックイン空港空席待ち人数検索のストアをクリアする
   */
  public clear() {
    this._store.dispatch(resetGetFlightsResult());
  }

  /**
   * チェックイン空港空席待ち人数検索APIの呼び出しと、呼び出し結果のStoreへの設定を行う
   */
  public callApi(condition: PostFlightsSearchFlightsRequest) {
    const call = this.api.flightsGetFlightsPost(condition);
    this.setResult(call);
  }
}
